export enum TrafficSourceForwardingMethods {
	IU = 'IU',
	WILEY = 'Wiley',
	SOMMET = 'Sommet',
	GUS = 'GUS',
	IUTM = 'IUTM'
}
